export default __webpack_public_path__ + "static/media/Minicard_7s.06e96ac0.svg";